/** The three hidden items. Each player always carries exactly one. */
export type Item = 'rock' | 'paper' | 'scissors';

export const ITEMS: readonly Item[] = ['rock', 'paper', 'scissors'];

const BEATS: Record<Item, Item> = { rock: 'scissors', scissors: 'paper', paper: 'rock' };

/** True when `a` defeats `b`: rock crushes scissors, scissors cut paper, paper wraps rock. */
export function beats(a: Item, b: Item): boolean {
  return BEATS[a] === b;
}

/** The item that defeats `item`. */
export function counterTo(item: Item): Item {
  return (ITEMS.find((candidate) => beats(candidate, item)) ?? 'rock') as Item;
}

export type Outcome = 'win' | 'lose' | 'tie';

/** Outcome for the holder of `mine` when meeting `theirs`. */
export function resolveItems(mine: Item, theirs: Item): Outcome {
  if (mine === theirs) return 'tie';
  return beats(mine, theirs) ? 'win' : 'lose';
}
